import { ThemeProvider, useColorScheme } from "@mui/material";
import { getTheme } from "@/style/theme.ts";
import { NuqsAdapter } from "nuqs/adapters/tanstack-router";
import { ErrorBoundary, Provider as RollbarProvider } from "@rollbar/react";
import AutoThemeSwitcher from "@/hoc/AutoThemeSwitcher.tsx";
import { fr } from "date-fns/locale";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Rollbar from "rollbar/replay";
import { getBrowserCompatibility } from "@/services/support.ts";

type ProvidersProps = {
  children: React.ReactNode;
};

const Providers = ({ children }: ProvidersProps) => {
  const theme = getTheme();
  const browserCompatibility = getBrowserCompatibility();

  const rollbarConfig: Rollbar.Configuration = {
    enabled: browserCompatibility.isCompatible,
    accessToken: import.meta.env.VITE_ROLLBAR_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      client: {
        javascript: {
          code_version: import.meta.env.VITE_APP_VERSION,
          source_map_enabled: true,
        },
      },
    },
    replay: {
      enabled: true,
    },
    environment: import.meta.env.MODE,
  };

  return (
    <ThemeProvider theme={theme}>
      <AutoThemeSwitcher>
        <RollbarProvider config={rollbarConfig}>
          <ErrorBoundary>
            <LocalizationProvider
              dateAdapter={AdapterDateFns}
              adapterLocale={fr}
            >
              <NuqsAdapter>{children}</NuqsAdapter>
            </LocalizationProvider>
          </ErrorBoundary>
        </RollbarProvider>
      </AutoThemeSwitcher>
    </ThemeProvider>
  );
};

export default Providers;
